import { useEffect, useState } from "react";

import { resolvePromiseWithDelay } from "@smart/itops-utils-basic";

import { getLocalSmokeballAppContext, observeChange } from "./utils";
import { Matter, UseLocalApiOptions } from "../types";

export const useMatters = ({ context, observe }: UseLocalApiOptions) => {
  const [loading, setLoading] = useState(true);
  const findLocalMatter = (matterId?: string) =>
    getLocalSmokeballAppContext()?.matters.find((m) => m.id === matterId);

  const [currentMatter, setCurrentMatter] = useState<Matter>();
  const shouldObserve = observe?.includes("matters");

  useEffect(() => {
    if (shouldObserve) {
      setLoading(true);
      setCurrentMatter(findLocalMatter(context.matterId));
      setLoading(false);
      observeChange("matters", () =>
        setCurrentMatter(findLocalMatter(context.matterId)),
      );
    }
  }, [context, shouldObserve]);

  return {
    loading,
    get: (matterId?: string) => {
      const matter = findLocalMatter(matterId || context?.matterId);
      return resolvePromiseWithDelay(matter as Matter);
    },
    current: currentMatter,
  };
};
